export default __webpack_public_path__ + "static/media/gpDownload.76a6fcd0.png";